<template>
    <div>
        <el-dialog title="日志信息" width: :visible.sync="recordflag">
           <avue-crud :data="record" width="70%" :option="tableOption" @row-click="showRow">
                <template slot-scope="scope" slot="menuLeft" >
                    <el-button @click="showcomment" :disabled = "recordStatus" size="mini" icon="el-icon-view" type="primary">查看评论</el-button>
                </template>
                <template slot-scope="scope" slot="id">
                    <el-radio class="radio" v-model="radiorecord"  :label="scope.row.id"></el-radio>
                </template>
                 <template slot-scope="scope" slot="videoPaths">
                    <el-button type="primary" size="small" @click="showVideo(scope.row.videoPaths,'mp4')">视频播放</el-button>
                </template>
                <template slot-scope="scope" slot="voicePaths">
                    <el-button type="primary" size="small" @click="showVideo(scope.row.voicePaths,'mp3')">音频播放</el-button>
                </template>
            </avue-crud>
        </el-dialog>
        <!--查看视频-->
        <videolist ref="childvideo"></videolist>
        <!--查看评论信息-->
        <comment ref="childcomment"></comment>
       
    </div>
</template>
<script>
    import {getFeedbacks} from '@/api/admin/taskManagement'
    import { objKeySort } from '@/util/ajaxsign'
    import {getImgLink} from '@/config/env'
    import videolist from './video.vue'
    import comment from './comment.vue'
    import insertrecord from './insertrecord.vue'
    export default {
        components: {videolist,comment,insertrecord},
        data() {
            return {
                recordflag : false,
                projectId : '',
                radiorecord : '',
                record : [],
                recordStatus : true,
                state : '',
                tableOption : {
                  addBtn : false,
                  refreshBtn : false,
                  columnBtn : true,
                  editBtn : true,
                  delBtn : true,
                  menu : false,
                  page:true,
                  border : true,
                  align:'center',
                  menuAlign:'center',
                  height : window.innerHeight - 290,
                  serviceType : '',
                  index:false,
                  column:[
                    {
                      label:'',
                      prop:'id',
                      width:40,
                      solt:true
                    },
                    {
                      label:'师傅名称',
                      prop:'userName'
                    },{
                      label:'日志类型',
                      prop:'type',
                      formatter : function(row, value , label, column){
                          return row.type==1?'结果反馈':'问题反馈';
                      }
                    },{
                      label:'内容信息',
                      prop:'tips',
                      overHidden : true
                    },{
                        label:'查看图片',
                        prop:'imgPaths',
                        type:'upload',
                        imgFullscreen:true,
                        imgType:'card',
                        listType:'picture-card',
                        span:12,
                    },{
                        label:'视频',
                        prop:'videoPaths',
                        solt:true
                    },{
                        label:'音频',
                        prop:'voicePaths',
                        solt:true
                    },{
                      label:'创建时间',
                      prop:'createTime',
                      overHidden : true,
                      type: 'date',
                      format: 'yyyy-MM-dd HH:mm:ss',
                      valueFormat: 'yyyy-MM-dd HH:mm:ss'
                    }
                  ]
                }
            }
        },
        created() {},
       
        methods: {
            showRow(row){
                this.radiorecord = row.id;
                this.serviceType = row.type;
                this.recordStatus = false;
            },
            //设置展示
             recordstate(data,state){
                this.state = state;
                this.projectId = data;
                this.recordflag = true;
                this.getfeedback();
                this.recordStatus = true;
                this.radiorecord = null;
            },
            getfeedback(){
                getFeedbacks(objKeySort({projectId:this.projectId})).then(response =>{
                    for(var i=0;i<response.data.data.length;i++){
                        response.data.data[i].imgPaths = response.data.data[i].imgPaths.split(',');
                        if(response.data.data[i].imgPaths.length>0){
                            for(var j=0;j<response.data.data[i].imgPaths.length;j++){
                                response.data.data[i].imgPaths[j] = {'label':'问题图片'+(j+1),value:getImgLink(response.data.data[i].imgPaths[j])}
                            }
                        }
                    }
                    this.record =response.data.data;
                })
            },
            //查看视频详情
            showVideo(data,type){
                this.$refs.childvideo.viderstate(data,type);
            },
            //查看评论信息
            showcomment(){
                this.$refs.childcomment.commentstate(this.radiorecord,this.serviceType,this.state);
            }
        }
    }
</script>